import React from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import KpiReportPageAction from "../page-action/KpiReportPageAction";
import MonthlyKpiReportTable from "../../../components/table/all-tables/reportable/monthlykpireport/MonthlyKpiReportTable";
import { kpiReport } from "../../../locales/en";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";

export default function MonthlyKpiReport() {
  return (
    <>
      <TablePagesTitle mainTitle={kpiReport?.main_title} />

      <KpiReportPageAction subheading={kpiReport?.main_title} />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-4 mb-2 mx-0 ">
          <div className="col-md-12">
            <MonthlyKpiReportTable />
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
}
